import { FaAngleUp } from "react-icons/fa";
import styled from "styled-components";
export const FooterContainer = styled.footer`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;
  padding: 10px 0px;
  color: ${({ theme }) => theme.colors.gray.dark};
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: 500;
  div {
    margin: 0 30px;
  }
  a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.gray.dark};

    &:hover {
      color: ${({ theme }) => theme.colors.green.light};
    }
  }
  @media ${({ theme }) => theme.devices.tablet} {
    flex-direction: column;
    div {
      margin: 0px;
    }
  }
`;

export const BackTop = styled.div`
  color: ${({ theme }) => theme.colors.gray.dark};
  padding: 15px 16px;
  display: flex;
  justify-content: center;
  cursor: pointer;
  align-self: self-end;
  font-size: ${({ theme }) => theme.fontSize.md};
  align-items: center;
  margin-top: 20px;
`;

export const ArrowContainer = styled.div`
  background-color: ${props => props.theme.colors.gray.dark};
  width: 2em;
  height: 2em;
  margin-left: 16px;
  border-radius: 50%;
`;

export const ArrowUp = styled(FaAngleUp).attrs(() => ({
  icon: FaAngleUp,
}))`
  right: 16px;
  margin-left: -9px;
  margin-top: -3px;
  padding-left: 16px;
  padding-right: 16px;
  font-size: ${({ theme }) => theme.fontSize.lg};
  color: ${props => props.theme.colors.white.normal};
`;

export const Footer = styled.footer`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.colors.black.gradiente01Footer} 0%,
    ${({ theme }) => theme.colors.black.gradiente02Footer} 2%
  );
  color: ${({ theme }) => theme.colors.white.normal};
  z-index: 1;
  margin-top: -48px;
  height: 500px;

  @media ${({ theme }) => theme.devices.tablet} {
    height: auto;
  }

  @media ${({ theme }) => theme.devices.mobileL} {
    height: auto;
    background: linear-gradient(
      180deg,
      ${({ theme }) => theme.colors.black.gradiente01Footer} 0%,
      ${({ theme }) => theme.colors.black.gradiente02Footer} 1%
    );
  }
`;

export const ColumnsContainer = styled.div`
  color: ${({ theme }) => theme.colors.white.normal};
  display: flex;
  flex-direction: column;
  flex: 4;
  justify-content: center;
  font-size: ${({ theme }) => theme.fontSize.sm};
  @media ${({ theme }) => theme.devices.tablet} {
    flex-direction: column;
  }
`;

export const FooterContent = styled.div`
  display: flex;
  max-width: ${({ theme }) => theme.siteWidth};
  justify-content: space-between;
  width: 100%;
  @media ${({ theme }) => theme.devices.tablet} {
    flex-direction: column;
  }
`;

export const Column = styled.div`
  display: flex;
  color: ${({ theme }) => theme.colors.white.normal};
  flex-direction: column;
  flex: 1;
  flex-wrap: wrap;
  @media ${({ theme }) => theme.devices.tablet} {
    padding-left: 25px;
  }
`;

export const SubMenu = styled.div`
  a {
    padding-top: 12px;
    font-size: ${({ theme }) => theme.fontSizePx.mm} !important;
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    color: ${({ theme }) => theme.colors.grayNew.gray2};
    font-weight: 400;
    line-height: 20px;
    @media ${({ theme }) => theme.devices.tablet} {
      text-align: start;
    }
    @media ${({ theme }) => theme.devices.mobileL} {
      padding-top: 8px;
    }
    display: flex;
    flex-direction: column;
    text-decoration-line: none;
    &:hover {
      color: ${({ theme }) => theme.colors.green.light};
    }

    @media ${({ theme }) => theme.devices.mobileL} {
      font-size: ${({ theme }) => theme.fontSizePx.md};
    }
  }
`;

export const FooterLogo = styled.img`
  width: 100%;
  height: auto;
  margin-top: 50px;
`;

export const CopyrightDiv = styled.div`
  flex: auto;
  color: ${({ theme }) => theme.colors.gray.dark};
  display: flex;
  justify-content: center;
  place-items: center;
  font-size: ${({ theme }) => theme.fontSize.sm};

  @media ${({ theme }) => theme.devices.tablet} {
    flex-direction: column;
  }
`;

export const ColumnTitle = styled.div`
  font-weight: 500;
  font-family: ${({ theme }) => theme.fonts.inter} !important;
  font-size: 18px;
  padding-bottom: 16px;
  @media ${({ theme }) => theme.devices.tablet} {
    padding-bottom: 8px;
    height: 50px;
  }

  @media ${({ theme }) => theme.devices.laptop} {
    padding-right: 20px;
    height: 38px;
  }
  @media ${({ theme }) => theme.devices.mobileL} {
    padding-bottom: 4px;
  }
  @media ${({ theme }) => theme.devices.tabletS} {
    height: auto;
  }
`;
export const LogoContainer = styled.div`
  width: 10%;
  height: 10%;
  padding: 0px 0px 20px 0px;
  align-self: center;
  @media ${({ theme }) => theme.devices.tablet} {
    width: 40%;
    height: 40%;
  }
`;
export const SpanContainer = styled.div`
  padding: 45px 0px 15px 0px;
  width: 100%;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: 600;
  a {
    text-decoration: none;
    color: #fff;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  justify-content: center;
  flex-flow: wrap;
  box-sizing: border-box;
  width: 100%;
  padding: 30px 0px 30px 40px;
  @media ${({ theme }) => theme.devices.mobileL} {
    flex-flow: column;
    padding: 0px;
  }

  @media ${({ theme }) => theme.devices.tablet} {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    padding: 0px;
  }
  @media ${({ theme }) => theme.devices.tabletS} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    padding: 0px;
  }
`;

export const ContainerContent = styled.div`
  max-width: 330px;
  padding: 15px 10px;
  box-sizing: border-box;
  border-radius: 7px;
  margin: 10px 12px;
  flex: 1 1 0;
  display: flex;
  justify-content: left;
  flex-direction: column;

  @media ${({ theme }) => theme.devices.tablet} {
    max-width: 100%;
    align-items: start;
    justify-content: start;
    padding: 20px 30px;
    margin: 0px;
    width: 100%;
  }
`;

export const BackTopSpanContainer = styled.div`
  width: 100%;
  text-align-last: end;
  font-size: ${({ theme }) => theme.fontSize.md};
  font-weight: bold;
`;

export const SocialMedia = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  width: fit-content;
  padding: 15px 10px;
  margin: 10px 12px;
  gap: 0px;

  @media ${({ theme }) => theme.devices.laptop} {
    margin-boton: 30px;
  }
  @media ${({ theme }) => theme.devices.tablet} {
    align-items: start;
    padding-left: 30px;
    padding-right: 0px;
    margin-left: 0px;
    margin-right: 0px;
  }
  @media ${({ theme }) => theme.devices.mobileL} {
    width: 100%;
    grid-column: auto / span 2;
    align-items: center;
    padding-left: 0px;
  }

  p {
    color: #fff;
    margin: 0;
    font-size: 18px;
    font-family: ${({ theme }) => theme.fonts.inter};
    font-weight: 500;
    line-height: 29px;
    height: 38px;

    @media ${({ theme }) => theme.devices.tablet} {
      font-size: ${({ theme }) => theme.fontSizePx.md2};
    }
    @media ${({ theme }) => theme.devices.laptop} {
      padding-bottom: 16px;
    }
  }
`;

export const SocialMediaIcons = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding-top: 30px;

  @media ${({ theme }) => theme.devices.laptop} {
    padding-top: 18px;
  }
  @media ${({ theme }) => theme.devices.mobileL} {
    padding-top: 18px;
  }
`;

export const SocialMediaIcon = styled.a`
  width: 32px;
  height: 32px;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: #fff;
    font-size: 1.5rem;
  }
  &:hover {
    filter: opacity(0.8);
  }
`;

export const LogoSocialMedia = styled.img`
  width: 100%;
`;

export const DividerVertical = styled.div`
  width: 1px;
  margin-top: 10px;
  height: 110%;
  background-color: #fff;
`;
